import { createMoTreeFromFlatMavenirTree } from '@utils/treeFormatter/treeFormatter';

import { IFlatMoTreeNode } from '@interfaces/components/tree';

import { FLAT_NODE_PATH_SEPARATOR } from '@constants/common';

export const filterAndCreateMoTree = (data: IFlatMoTreeNode[], isEditMode?: boolean) => {
	const filteredData = isEditMode
		? data
			.filter((node) => node.isChecked || node.countOfChecked > 0)
			.map((node) => ({ ...node }))
		: data;

	return createMoTreeFromFlatMavenirTree(filteredData);
};

export const extractTemplateTime = (date?: string) => date?.match(/(\d{1,2}:\d{2}\s(?:AM|PM))/i)?.[1];

export const sortTreeNodesWithParametersFirst = (nodes: IFlatMoTreeNode[]): IFlatMoTreeNode[] => {
	if (!nodes.length) {
		return nodes;
	}

	const childrenMap = new Map<string, IFlatMoTreeNode[]>();

	nodes.forEach(node => {
		const lastSlashIndex = node.path.lastIndexOf(FLAT_NODE_PATH_SEPARATOR);
		const parentPath = lastSlashIndex === -1 ? '' : node.path.substring(0, lastSlashIndex);

		if (!childrenMap.has(parentPath)) {
			childrenMap.set(parentPath, []);
		}

		childrenMap.get(parentPath)!.push(node);
	});

	const result: IFlatMoTreeNode[] = [];
	const processed = new Set<string>();
	const stack: string[] = [''];

	const addNodesToStack = (nodeList: IFlatMoTreeNode[]) => {
		const tempObjects: string[] = [];
		const tempParams: string[] = [];

		for (let i = nodeList.length - 1; i >= 0; i--) {
			if (nodeList[i].nodeType === undefined) {
				tempParams.push(nodeList[i].path);
			} else {
				tempObjects.push(nodeList[i].path);
			}
		}

		stack.push(...tempObjects, ...tempParams);
	};

	while (stack.length > 0) {
		const currentPath = stack.pop()!;
		const children = childrenMap.get(currentPath) || [];

		if (currentPath !== '') {
			const node = nodes.find(n => n.path === currentPath)!;

			if (processed.has(node.path)) {
				continue;
			}

			result.push(node);
			processed.add(node.path);
		}

		addNodesToStack(children);
	}

	return result;
};
